import { z } from 'zod';
/**
 * Fido — schemi condivisi per la modifica del fido (limite di scoperto) di un
 * utente business da parte di un ADMIN (F-012).
 *
 * Boundary euro→cents: l'admin ragiona in euro; la conversione a BigInt cents
 * avviene nel route handler (NON dentro lo schema) tramite `euroToCents`.
 *
 * `.strict()`: rifiuta campi extra nel body per evitare mass-assignment.
 */
/* -------------------------------------------------------------------------- */
/* Decision — esito del modal grace/blocco/annulla in caso di sconfinamento    */
/* -------------------------------------------------------------------------- */
/**
 * Decisione presa dall'admin quando una riduzione di fido provoca uno
 * sconfinamento del saldo:
 *   - GRACE  → applica la riduzione + concede grace period
 *   - BLOCK  → applica la riduzione + blocca immediatamente il wallet
 *   - NONE   → nessuno sconfinamento (default): applica e basta
 */
export const fidoDecisionEnum = z.enum(['GRACE', 'BLOCK', 'NONE']);
/* -------------------------------------------------------------------------- */
/* Action — valore persistito su FidoAuditEntry.action                         */
/* -------------------------------------------------------------------------- */
/**
 * Azione registrata nella riga immutabile `FidoAuditEntry.action`.
 * Tenuto come tuple `as const` per derivarne sia il tipo sia (se serve) un
 * enum Zod a valle, senza accoppiare lo schema input a questo dominio.
 */
export const fidoActionEnum = ['SET', 'GRACE', 'BLOCK', 'UNBLOCK'];
/* -------------------------------------------------------------------------- */
/* updateFidoInputSchema — body di PATCH /api/v1/admin/clienti/:id/fido        */
/* -------------------------------------------------------------------------- */
export const updateFidoInputSchema = z
    .object({
    nuovoFidoEuro: z
        .number({ required_error: 'Il fido è obbligatorio' })
        .nonnegative('Il fido non può essere negativo')
        .finite('Valore non valido'),
    motivazione: z
        .string({ required_error: 'La motivazione è obbligatoria' })
        .trim()
        .min(1, 'La motivazione è obbligatoria')
        .max(500, 'Massimo 500 caratteri'),
    decision: fidoDecisionEnum.default('NONE'),
})
    .strict();
/* -------------------------------------------------------------------------- */
/* Boundary helper — euro → cents (BigInt)                                      */
/* -------------------------------------------------------------------------- */
/**
 * Conversione boundary euro → cents. Eseguita nel route handler (non nello
 * schema) perché il modello dominio/Prisma lavora in `BigInt` cents mentre il
 * form admin invia euro come `number`.
 *
 * `Math.round` neutralizza gli errori di floating point (es. 19.99 * 100).
 */
export function euroToCents(euro) {
    return BigInt(Math.round(euro * 100));
}
//# sourceMappingURL=fido.js.map